require('imgix.js')

imgix.config.host = 'zollverein-cm.imgix.net'
imgix.config.useHttps = true
imgix.config.srcAttribute = 'data-src'
imgix.config.srcsetAttribute = 'data-srcset'
imgix.config.sizesAttribute = 'data-sizes'
